import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { sendParticipantDataEdited } from '../../services/participants'
import { onSetOpenToastSuccess } from '../UserNotificationToast/UserNotificationToast.actions'
import { ERROR_MESSAGE } from '../../config/settings/constants'

export const SET_EDIT_MODAL_SHOW_SUCCESS = 'SET_EDIT_MODAL_SHOW_SUCCESS'
export const onSetEditModalShowSuccess = makeActionCreator(SET_EDIT_MODAL_SHOW_SUCCESS, 'payload')

export const SET_EDIT_MODAL_FUNCTION_SUCCESS = 'SET_EDIT_MODAL_FUNCTION_SUCCESS'
export const onSetEditModalFunctionSuccess = makeActionCreator(SET_EDIT_MODAL_FUNCTION_SUCCESS, 'payload')

export const SET_EDIT_START_DATE_SUCCESS = 'SET_EDIT_START_DATE_SUCCESS'
export const onSetEditStartDateSuccess = makeActionCreator(SET_EDIT_START_DATE_SUCCESS, 'payload')

export const SET_EDIT_END_DATE_SUCCESS = 'SET_EDIT_END_DATE_SUCCESS'
export const onSetEditEndDateSuccess = makeActionCreator(SET_EDIT_END_DATE_SUCCESS, 'payload')

export const SEND_PARTICIPANT_DATA_EDITED = 'SEND_PARTICIPANT_DATA_EDITED'
export const SEND_PARTICIPANT_DATA_EDITED_ERROR = 'SEND_PARTICIPANT_DATA_EDITED_ERROR'
export const SEND_PARTICIPANT_DATA_EDITED_SUCCESS = 'SEND_PARTICIPANT_DATA_EDITED_SUCCESS'

export const onSendParticipantDataEdited = makeActionCreator(SEND_PARTICIPANT_DATA_EDITED)
export const onSendParticipantDataEditedError = makeActionCreator(SEND_PARTICIPANT_DATA_EDITED_ERROR, 'payload')
export const onSendParticipantDataEditedSuccess = makeActionCreator(SEND_PARTICIPANT_DATA_EDITED_SUCCESS, 'payload')

export const onSendParticipantDataEditedThunk = payload => async dispatch => {
  dispatch(onSendParticipantDataEdited())
  try {
    const { onSuccessCallback, ...rest } = payload
    await sendParticipantDataEdited({ body: rest, actionType: SEND_PARTICIPANT_DATA_EDITED })
    return batch(() => {
      dispatch(
        onSetOpenToastSuccess({
          open: true,
          message: 'Participante editado con éxito',
          severity: 'success',
          handleClose: onSuccessCallback
        })
      )
    })
  } catch (error) {
    return batch(() => {
      dispatch(onSetOpenToastSuccess({ open: true, message: ERROR_MESSAGE, severity: 'error' }))
      dispatch(onSendParticipantDataEditedError({ error }))
    })
  }
}
